import Cookies from 'js-cookie';

import type { AwsWafConfig } from '../types';

const AWS_CAPTCHA_TOKEN_COOKIE_NAME = 'aws-captcha-token';

/**
 * Returns `true` (and narrows the type) when both required fields are present and non-empty.
 */
export function isValidAwsWafConfig(
  awsWafConfig: AwsWafConfig | null | undefined
): awsWafConfig is AwsWafConfig {
  return !!(awsWafConfig?.integrationUrl && awsWafConfig?.apiKey);
}

/**
 * Function to get the value from the token cookie, ensuring safety in case the function throws an error.
 *
 * @returns String
 */
export function getAwsCaptchaTokenValue() {
  try {
    const value = Cookies.get(AWS_CAPTCHA_TOKEN_COOKIE_NAME) || '';

    if (!value || typeof value !== 'string') {
      return '';
    }

    return value;
  } catch (e) {
    // Make sure we return a value even if there was an error
    return '';
  }
}
